/* ============
 * Dashboard
 * ============
 *
 * This is the dashboard page.
 */

import packageService from './../../services/package';
import packageOrderProductService from './../../services/packageOrderProduct';
import orderProductService from './../../services/orderProduct';
import { mapGetters, mapMutations } from 'vuex';
import Forms from './../../utils/forms/forms';

export default {
  data() {
    return {
       form: new Forms({
        orderProductId: {
          value: '',
          type: 'select',
        },
        quantity: {
          value: '',
          type: 'text',
        },
        quantityUnit: {
          value: '',
          type: 'select',
        },
        grossWeight: {
          value: '',
          type: 'text',
        },
        netWeight: {
          value: '',
          type: 'text',
        },
        stackWeight: {
          value: '',
          type: 'text',
        },
        bestBefore: {
          value: new Date().toISOString().slice(0, 10),
          type: 'date',
        },
        maxTopLoad: {
          value: '',
          type: 'text',
        },
        batchLotNumber: {
          value: '',
          type: 'text',
        },
        temperatureRequirement: {
          value: '',
          type: 'text',
        },
        packageId: {
          value: '',
          type: 'hidden',
        },
      }),
      loading: false,
    };
  },

  computed: {
    ...mapGetters({
      currentOrder: 'currentOrder',
      orderProducts: 'allOrderProducts',
    }),

    loadForms() {
      this.form.setOptions('orderProductId', this.orderProducts.filter(function(op) {
        return op.quantityConfirmed != op.quantityPacked;  
      }));
      const qtyUnitOptions = [
        {"id": "PCE", "name": "Piece"},
        {"id": "KGM", "name": "Kilo"},
        {"id": "LTR", "name": "Litre"},
        {"id": "MTR", "name": "Metre"}, 
      ];
      
      this.form.setOptions('quantityUnit', qtyUnitOptions);
      this.form.setFieldValue('packageId', this.$store.state.modal.modalProps.packageId)
      
    }, 
  },

  created() {
    this.loadForms;
  },

  watch:{
    'form.orderProductId': function (val) {
      if (val != '') {
        const currentOrderProduct = this.orderProducts.filter(function(op) {
          return op.id == val;  
        });
        
        this.form.setFieldValue('quantity', currentOrderProduct[0].quantityUnpacked.toString());
        this.form.setFieldValue('quantityUnit', 'PCE');
        const previousOrderProductPackage = currentOrderProduct[0].prevOrderProductPackage;
        if (previousOrderProductPackage) {
          this.form.setFieldValue('quantityUnit', previousOrderProductPackage.quantity_unit.toString());
          this.form.setFieldValue('grossWeight', previousOrderProductPackage.gross_weight.toString());
          this.form.setFieldValue('netWeight', previousOrderProductPackage.net_weight.toString());
          this.form.setFieldValue('stackWeight', previousOrderProductPackage.stack_weight.toString());
          if (previousOrderProductPackage.best_before) {
            this.form.setFieldValue('bestBefore', previousOrderProductPackage.best_before);
          }
          this.form.setFieldValue('maxTopLoad', previousOrderProductPackage.max_top_load.toString());
          this.form.setFieldValue('batchLotNumber', previousOrderProductPackage.batch_lot_number);
          this.form.setFieldValue('temperatureRequirement', previousOrderProductPackage.temperature_requirement);
        } else if (currentOrderProduct[0].fieldsJSON && currentOrderProduct[0].fieldsJSON.weightMultipack != null) {
          const weightMultipackStr = String(currentOrderProduct[0].fieldsJSON.weightMultipack);
          const weight = (parseFloat(weightMultipackStr.replace(',', '.')) * currentOrderProduct[0].quantityUnpacked).toFixed(0);
          this.form.setFieldValue('grossWeight', weight.toString());
          this.form.setFieldValue('netWeight', weight.toString());
          this.form.setFieldValue('stackWeight', weight.toString());
        }
      }
    },
  },

  methods: {
    ...mapMutations({
      toggle: 'TOGGLE_MODAL',
      unsetModalContent: 'UNSET_MODAL_CONTENT',
      modalProps: 'SET_MODAL_PROPS',
    }),

    /*
    * Invoked upon clicking the "save button"
    * 
    */

    store(){
      //this.form.loading = true;
      packageOrderProductService.store(this.form.data())
      .then((data) => {
        orderProductService.all(this.currentOrder.id);
        packageOrderProductService.all(this.currentOrder.id)
        packageService.all(this.currentOrder.id)
        this.$message({
            showClose: true,
            message: this.$t('static.packageOrderProduct.add.success'),
            customClass: 'success',
        });
        this.closeModal();
      })
      .catch((errors) => {
        this.form.loading = false;
        this.form.recordErrors(errors);
        let message = this.$t('static.packageOrderProduct.add.error');
        if (errors.quantityExceedError) {
          message = this.$t('static.packageOrderProduct.add.quantityExceedError');
        }
        this.$message({
          showClose: true,
          message,
          customClass: 'error',
        });
      });
    },
    /*
    * Closes the modal
    */
    closeModal() {
      this.toggle(false);
      this.unsetModalContent();
    },
  },
  components: {
    VForm: require('./../../components/form/form.vue'),
    VMessage: require('./../../components/form/message/message.vue'),
  },
};



// WEBPACK FOOTER //
// ./src/app/components/addPackageOrderProduct/addPackageOrderProduct.js